export function Header() {
    return (
      <header className="header">
        <div id="icon"></div>
        <h1>Panorama</h1>
      </header>
    );
  }